export default __webpack_public_path__ + "static/media/NFTDogs-only100-in1season-1x-4x.783d9996.png";